module.exports = __webpack_public_path__ + "static/media/img_3856.24b66b36.jpg";